import { render, staticRenderFns } from "./CreateFast.vue?vue&type=template&id=b3c833aa&scoped=true&"
import script from "./CreateFast.vue?vue&type=script&lang=js&"
export * from "./CreateFast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c833aa",
  null
  
)

export default component.exports